<template>
  <!--  <router-view></router-view>-->
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.name"/>
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.name"/>
  </router-view>
</template>


<script>
export default {
  data() {
    return {
      // screenHeight: document.body.offsetWidth
    }
  },
  watch: {
    // screenHeight: {
    //   immediate: true,
    //   handler(newValue, oldValue) {
    //     if (!this.timer) {
    //       this.resetHeight(newValue)
    //       this.timer = true
    //       let that = this
    //       setTimeout(function () {
    //         that.timer = false
    //       }, 700)
    //     }
    //   },
    // }
  },
  mounted() {
    // this.windowOnresize()
    // this.resetHeight()
    // this.resetTop() // 设置顶部是否需要占位高度,ios需要高度为44px的占位高
  },
  methods: {
    // resetTop() {
    //   // // 判断当前系统是ios还是安卓
    //   // let u = navigator.userAgent;
    //   // let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   if (this.isIOS()) {
    //     let app = document.querySelector('#app')
    //     app.style.paddingTop = '44px'
    //   }
    // },
    // isIOS() {
    //   let u = navigator.userAgent;
    //   let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   return isIOS
    // },
    windowOnresize() {
      window.onresize = (res) => {
        let that = this;
        if (that.resizeFlag) clearTimeout(that.resizeFlag);
        that.resizeFlag = setTimeout(function () {
          that.screenHeight = window.innerWidth
          that.resizeFlag = null;
        }, 100);
      }
    },
    resetHeight(newValue) {
      var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // console.log(window.innerWidth , document.documentElement.clientWidth , document.body.clientWidth)
      // console.log(window.innerHeight , document.documentElement.clientHeight , document.body.clientHeight)
      let app = document.querySelector('#app')
      app.style.height = h + 'px'
      app.style.width = w + 'px'
    },
  }
}
</script>
<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: transparent;
  height: 100%;
  width: 100%;
  //overflow-x: hidden;
  //overflow-y: hidden;
}

html,
body {
  //height: 100%;
  background-color: #f5f5f5;
  //margin: 0 auto !important;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
